export const findNodeById = (nodes, id) => {
  if (!Array.isArray(nodes) || nodes.length === 0) return null;

  for (const node of nodes) {
    if (node?.id === id) {
      return node;
    }

    const children = Array.isArray(node?.children) ? node.children : [];
    const found = findNodeById(children, id);
    if (found) {
      return found;
    }
  }

  return null;
};

export const flattenTree = (nodes) => {
  if (!Array.isArray(nodes) || nodes.length === 0) return [];

  const output = [];
  const stack = [...nodes].reverse();

  while (stack.length > 0) {
    const current = stack.pop();
    if (!current) continue;

    output.push(current);

    const children = Array.isArray(current.children) ? current.children : [];
    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i];
      if (child) stack.push(child);
    }
  }

  return output;
};

